import { type ParsedUrlQuery } from 'querystring';

import { extractBase36Id } from '@/utils';

export const competitionQueryParams = (query: ParsedUrlQuery) => {
  const competition =
    query.competition instanceof Array
      ? query.competition.join('')
      : query.competition;
  const competitionId = extractBase36Id(competition);
  const sport = query.sport;

  if (!competitionId || typeof sport !== 'string') {
    throw new Error('url is malformed');
  }

  const roundId = !query.r ? undefined : Number(query.r);

  return { competitionId, sport, roundId };
};
